import { ApiResponse } from '@ace/core';

import { EndpointCallParams } from '@core/api/endpointCallParams';
import { IApiStore } from '@core/api/apiStore';

export type DeleteProcedureImageParams = {
    id: string;
};

export const performDeleteProcedureImage = async (
    api: IApiStore,
    params: EndpointCallParams<DeleteProcedureImageParams>,
): Promise<ApiResponse> => {
    const { payload, ...rest } = params;
    const req = api.delete(
        `contentfileprovider-app/api/v1/FileProvider/procedurepreview/${payload.id}`,
        {
            ...rest,
            payload: {},
        },
    );

    return req;
};
